import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useStatsigClient } from '@statsig/react-bindings';
import { dynamicConfigs, adDisplayConfigKeys } from '../../utils/statsig';

export const useAdDynamicConfig = () => {
    const user = useSelector((state) => state.auth?.user);
    const [showAds, setShowAds] = useState(false);

    const { client } = useStatsigClient();
    const config = client.getDynamicConfig(dynamicConfigs.AD_DISPLAY)?.value;
    const {
        clubSearch,
        eventProfile,
        eventSearch,
        forgotPassword,
        home,
        inbox,
        playerProfile,
        playerSearch,
        seoResults,
        signIn,
        search,
    } = config?.pages || {};

  const extractConfig = (pageConfig) => {
    if (!pageConfig) {
        return;
    }

    return adDisplayConfigKeys.reduce((acc, key) => {
      if (key in pageConfig) {
        acc[key] = pageConfig[key];
      }
      return acc;
    }, {});
  };

  const clubSearchConfig = extractConfig(clubSearch);
  const eventProfileConfig = extractConfig(eventProfile);
  const eventSearchConfig = extractConfig(eventSearch);
  const forgotPasswordConfig = extractConfig(forgotPassword);
  const homeConfig = extractConfig(home);
  const inboxConfig = extractConfig(inbox);
  const playerProfileConfig = extractConfig(playerProfile);
  const playerSearchConfig = extractConfig(playerSearch);
  const searchConfig = extractConfig(search);
  const seoResultsConfig = extractConfig(seoResults);
  const signInConfig = extractConfig(signIn);

    useEffect(() => {
        if (user) {
            const isPowerUser = user?.isPowered;

            if (!isPowerUser) {
                setShowAds(true);
            }
        } else {
          setShowAds(true);
        }
    }, [user]);

    return {
        showAds,
        clubSearchConfig,
        eventProfileConfig,
        eventSearchConfig,
        forgotPasswordConfig,
        homeConfig,
        inboxConfig,
        playerProfileConfig,
        playerSearchConfig,
        searchConfig,
        seoResultsConfig,
        signInConfig,
    };
};
